/* unplugin-vue-components disabled */var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{staticClass:"w-full",style:({ height: _vm.widgets.content.height + 'px' }),attrs:{"src":_vm.widgets.content.video,"poster":_vm.widgets.content.img,"controls":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }